import { type Component, type ComponentProps, Show } from "solid-js";
import { getUserEndDate } from "~/solidJs/shared";
import { getUserStore } from "../HeaderMain/models/userStore";

export const EndOfSubscriptionCounter: Component<{
	children: Component<ComponentProps<"div">>;
}> = (props) => {
	const statusText = () => {
		const endTime = getUserEndDate(getUserStore());
		if (!endTime) return "Active";
		return `Active until ${endTime}`;
	};

	return (
		<Show when={getUserStore()?.end_time && getUserStore()?.start_time}>
			<props.children>{statusText()}</props.children>
		</Show>
	);
};
